__turbopack_context__.v({
  "container": "BlogArticles-module__u7nYuW__container",
});
